export default "__VITE_ASSET__DWn3rO_k__"